import { render } from "./PaymentMethodsTitle.vue?vue&type=template&id=3bd94689"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3bd94689"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bd94689', script)) {
    api.reload('3bd94689', script)
  }
  
  module.hot.accept("./PaymentMethodsTitle.vue?vue&type=template&id=3bd94689", () => {
    api.rerender('3bd94689', render)
  })

}

script.__file = "src/views/settings/pageTitles/PaymentMethodsTitle.vue"

export default script